import * as React from "react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Box from "@mui/material/Box";
export default function SelectOpt({
  option,
  onChange,
  value,
  placeholder,
  size,
}) {
  // console.log("==>", option);
  return (
    <div>
      <FormControl variant="standard" sx={{ minWidth: 85 }}>
        <Select
          labelId="demo-simple-select-standard-label"
          id="demo-simple-select-standard"
          value={value}
          onChange={onChange}
          label="Age"
          placeholder={placeholder}
          sx={{}}
        >
          {Array.isArray(option) &&
            option?.map((data) => {
              return (
                <MenuItem value={data}>
                  <Box
                    component="span"
                    sx={{
                      background: data,
                      color: data,
                      fontWeight: "bold",
                      width: "64px",
                      mr: size && "30px",
                    }}
                  >
                    {data}
                  </Box>
                </MenuItem>
              );
            })}
        </Select>
      </FormControl>
    </div>
  );
}
